import React, { useState, useEffect } from 'react';

import OneArticle from '../Groups/OneArticle'

import API from '../Utilities/API'

export default (props) => {
    const [article, setArticle] = useState({});

    useEffect(() => {
        if (props.routeParams && props.routeParams['*'] && props.routeParams['*'].length > 0) {
            API.IntelligenceArticle(props.routeParams['*']).then((res) => {
                setArticle(res.data.Data);
            })
        }
    }, [])

    return article.id ? (
        <div style={{
            width: 1200,
            margin: 'auto',
            backgroundColor: 'rgb(24, 32, 38)',
            padding: 20,
            height: '100%',
            overflow: 'auto'
        }}>
            <OneArticle article={article} hideSelect />
            <div style={{ clear: 'both' }}></div>
        </div>
    ) : null;

}